import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Center,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Player from "../../vdoPlayer/player";
import YouTubeEmbed from "../../../components/YouTubeEmbed";
import axiosInstance from "../../../helpers/api";

/** 0 = YouTube restricted, 1 = VdoCipher, 2 = YouTube, 3 = Vimeo */
const isVdoCipher = (type) => Number(type) === 1;
const isYouTube = (type) => {
  const t = Number(type);
  return t === 0 || t === 2;
};
const isVimeo = (type) => Number(type) === 3;

const VideoPreviewModal = ({ isOpen, onClose, videoData }) => {
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [playBack, setPlayBack] = useState("");

  useEffect(() => {
    if (!isOpen || !videoData?.id) {
      setOtp("");
      setPlayBack("");
      setLoading(false);
      return undefined;
    }

    if (!isVdoCipher(videoData.video_type)) {
      setOtp("");
      setPlayBack("");
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    axiosInstance
      .get(`/admin/videos/otp/${videoData.id}`)
      .then((res) => {
        if (cancelled) return;
        setOtp(res?.data?.otp ?? "");
        setPlayBack(res?.data?.playbackInfo ?? "");
      })
      .catch(() => {
        if (cancelled) return;
        setOtp("");
        setPlayBack("");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [isOpen, videoData?.id, videoData?.video_type]);

  const renderPlayer = () => {
    if (isYouTube(videoData?.video_type)) {
      return (
        <YouTubeEmbed
          videoUrl={videoData?.url}
          videoType={Number(videoData?.video_type)}
        />
      );
    }

    if (isVimeo(videoData?.video_type)) {
      return (
        <Box
          w="100%"
          sx={{
            "& iframe": { width: "100%", minH: "320px", border: 0 },
          }}
          dangerouslySetInnerHTML={{ __html: videoData?.url || "" }}
        />
      );
    }

    if (isVdoCipher(videoData?.video_type)) {
      if (loading) {
        return (
          <Center minH="320px">
            <Spinner color="var(--text-primary)" />
          </Center>
        );
      }
      return <Player otp={otp} playbackInfo={playBack} data={videoData} />;
    }

    return (
      <Center minH="200px" color="var(--text-muted)" fontWeight="600">
        Unsupported video type
      </Center>
    );
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent bg="var(--surface-raised)" color="var(--text-primary)">
        <ModalHeader>{videoData?.title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <Box bg="gray" w="100%" borderRadius="8px" mb={4} overflow="hidden">
            {renderPlayer()}
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default VideoPreviewModal;
